import { BondRequest } from "@portal/api/bond-request/agent";
import { LoadingModal } from "@portal/components/layout/LoadingModal";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useRequest } from "../../../utils/request";

export const BondRequestRedirect = () => {
	const { id } = useParams();
	if (!id) throw new Error("Missing route param: id");
	const { get } = useRequest();
	const navigate = useNavigate();

	const { data, error } = useQuery({
		queryKey: ["quoteRedirect", id],
		queryFn: async () => await get<Pick<BondRequest, "suretyAccountId">>(`/v2/surety/quotes/${id}`),
	});

	useEffect(() => {
		if (data) {
			navigate(`/accounts/${data.suretyAccountId}/requests/${id}`, {
				replace: true,
			});
		}
	}, [data, id, navigate]);

	useEffect(() => {
		if (error) {
			navigate("/requests", { replace: true });
		}
	}, [error, navigate]);

	return <LoadingModal />;
};
